import React, { useState } from 'react';
import * as S from './FiltersButton.styles';
import { Badge } from '@/components/UI/Badge/Badge';
import { FiltersDrawer } from '@/components/Filters/FiltersDrawer';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';

export const FiltersButton = () => {
  const [filterCount, setFilterCount] = useState(0);
  const [isFiltersOpen, toggleFilters] = useToggleOpenState();

  return (
    <>
      <Badge hasIcon={filterCount > 0}>
        <S.FiltersButton onClick={toggleFilters} data-testid="filters-button">
          <S.FiltersButtonIcon />
        </S.FiltersButton>
      </Badge>
      <FiltersDrawer
        isOpen={isFiltersOpen}
        close={toggleFilters}
        setFilterCount={setFilterCount}
      />
    </>
  );
};
